import logo from "@/assets/images/logo.png";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

const TopBar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const navItems = (
    <>
      <li className="nav-item">
        <Link to="/">Lifestyle Medicine Mapper</Link>
      </li>
      <li className="nav-item">
        <a href="https://caspiahealth.com/newsletter">
          Healthy Today Newsletter
        </a>
      </li>
      <li className="nav-item">
        <a href="https://propatienttech.com/">For Physicians</a>
      </li>
      <li className="nav-item">
        <a href="https://caspiahealth.com/login">Sign In</a>
      </li>
    </>
  );

  return (
    <div className="relative">
      <div className="bg-gray-900 py-6">
        <div className="max-w-7xl mx-auto h-16 flex items-center justify-between px-6">
          <a
            href="https://caspiahealth.com"
            className="flex items-center gap-3 text-gray-300"
          >
            <img className="h-12 w-auto" src={logo} alt="Caspia Health Logo" />
            <span className="text-lg">Caspia Health</span>
          </a>
          {/* Hamburger Icon for Mobile */}
          <div className="block lg:hidden">
            <button
              onClick={toggleNavbar}
              className="text-gray-400 hover:text-white focus:outline-none focus:text-white"
            >
              {isOpen ? (
                <XMarkIcon className="h-6 w-6" />
              ) : (
                <Bars3Icon className="h-6 w-6" />
              )}
            </button>
          </div>
          {/* Desktop Navigation Links */}
          <ul className="hidden lg:flex lg:items-center lg:space-x-6 text-gray-300 hover:text-white transition">
            {navItems}
          </ul>
        </div>
        {/* Mobile Navigation Links */}
        <ul
          className={`lg:hidden mt-4 container px-6 ${
            isOpen ? "flex flex-col" : "hidden"
          } text-gray-300 hover:text-white transition`}
        >
          {navItems}
        </ul>
      </div>
    </div>
  );
};

export default TopBar;
